import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemsAtLocationComponent } from "./dashboard/items-at-location/items-at-location.component";
import { DashboardComponent } from "./dashboard/dashboard/dashboard.component";
import { ItemsLostDetailComponent } from "./dashboard/items-lost-detail/items-lost-detail.component";
import { AvgLifetimeDeltaComponent } from "./dashboard/avg-lifetime-delta/avg-lifetime-delta.component";
import { TargetReachDetailComponent } from "./dashboard/target-reach-detail/target-reach-detail.component";
import { ScanActionsListComponent } from "./management/scan-actions-list/scan-actions-list.component";
import { AvgTurnaroundTimeDetailComponent } from "./dashboard/avg-turnaround-time-detail/avg-turnaround-time-detail.component";
import { ProductAgeSummaryDetailComponent } from "./dashboard/product-age-summary-detail/product-age-summary-detail.component";
import { CustomerSummaryViewComponent } from "./dashboard/customer-summary-view/customer-summary-view.component";
import { ItemDetailsComponent } from "./management/item-details/item-details.component";
import { DeliveredProductsDetailComponent } from './dashboard/delivered-products-detail/delivered-products-detail.component';
import { ReturnedProductsDetailComponent } from './dashboard/returned-products-detail/returned-products-detail.component';
import { IncomingOutgoingProductsDetailComponent } from './dashboard/incoming-outgoing-products-detail/incoming-outgoing-products-detail.component';
import { BundleRatioDetailComponent } from './dashboard/bundle-ratio-detail/bundle-ratio-detail.component';
import { ItemsAtSiteOverTimeComponent } from './dashboard/items-at-location/items-at-site-over-time/items-at-site-over-time.component';
import { AddNewLaundryCustomerComponent } from './dashboard/add-new-laundry-customer/add-new-laundry-customer.component';
import { AddNewProductComponent } from './dashboard/add-new-product-type/add-new-product.component';
import { NewProductComponent } from "./dashboard/new-product/new-product.component"
import { ItemHistoryComponent } from './dashboard/item-history/item-history.component';
import { NewUserComponent } from "./dashboard/new-user/new-user.component"
import { CabinetUserSummaryComponent } from "./dashboard/cabinet-user-summary/cabinet-user-summary.component"
import { CabinetEventSummaryComponent } from "./dashboard/cabinet-event-summary/cabinet-event-summary.component"
import { UnauthorizedCabinetAccessSummaryComponent } from './dashboard/unauthorized-cabinet-access-summary/unauthorized-cabinet-access-summary.component';
import { AddNewAdminComponent } from './dashboard/add-new-admin/add-new-admin.component';
import { LoginComponent } from './dashboard/login/login.component';


const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'dashboard',
    children: [
      { path: 'new-admimn', component: AddNewAdminComponent},
      { path: 'new-customer', component: AddNewLaundryCustomerComponent },
      { path: 'new-product-type', component: AddNewProductComponent },
      { path: 'new-product', component: NewProductComponent },
      { path: 'new-user', component: NewUserComponent },

      { path: 'items-at-site', component: ItemsAtLocationComponent },
      { path: 'items-at-site-over-time', component: ItemsAtSiteOverTimeComponent },
      { path: 'items-lost', component: ItemsLostDetailComponent },

      { path: 'product-lifetime-delta', component: AvgLifetimeDeltaComponent },
      { path: 'avg-turnaround-time', component: AvgTurnaroundTimeDetailComponent },
      { path: 'age-summary', component: ProductAgeSummaryDetailComponent },

      { path: 'customer-summary', component: CustomerSummaryViewComponent },

      { path: 'container-target-reach', component: TargetReachDetailComponent },
      { path: 'bundle-ratio-outscans', component: BundleRatioDetailComponent },

      { path: 'incoming-outgoing-products', component: IncomingOutgoingProductsDetailComponent },
      { path: 'delivered-products', component: DeliveredProductsDetailComponent },
      { path: 'returned-products', component: ReturnedProductsDetailComponent },

      { path: 'item-history', component: ItemHistoryComponent },

      { path: '', pathMatch: 'full', component: DashboardComponent },

      { path: 'cabinet-user-summary', component: CabinetUserSummaryComponent },
      { path: 'cabinet-event-summary', component: CabinetEventSummaryComponent },
      { path: 'unauthorized-access-summary', component: UnauthorizedCabinetAccessSummaryComponent }
    ]
  },

  {
    path: 'management',
    children: [
      { path: 'scan-actions', component: ScanActionsListComponent },
      { path: 'items/:itemCuid', component: ItemDetailsComponent }
    ]
  },


  { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
